'use client';

import React from 'react';
import { Flex, Text, Spinner } from '@skin-seoul/design-system';
interface MotionLoaderProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  colorScheme?: 'primary' | 'neutral' | 'brand';
  showMessage?: boolean;
  className?: string;
}
const MotionLoader = ({
  message = 'Loading...',
  showMessage = true
}: MotionLoaderProps) => {
  return <Flex direction="column" align="center" justify="center" gap={3} p={6} borderRadius="12px" backgroundColor="generic.0" data-sentry-element="Flex" data-sentry-component="MotionLoader" data-sentry-source-file="MotionLoader.tsx">
      <Spinner size="lg" color="primary.500" animationDuration="0.8s" data-sentry-element="Spinner" data-sentry-source-file="MotionLoader.tsx" />
      {showMessage && <Text textStyle="paragraph.small" color="neutral.700" fontWeight="regular" textAlign="center">
          {message}
        </Text>}
    </Flex>;
};
export default MotionLoader;